






































































import userApi from "@/api/userApi";
import User, { USER_TYPE } from "@/model/user";
import { Component, Vue, Watch } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";

@Component({
  name: "CustomerSearch",
  components: {
    QErrors,
  },
})
export default class CustomerSearch extends Vue {
  public isShow = false;
  public customer = new User();
  public errors = {};
  public noResult = false;
  public search = {
    email: null,
    type: USER_TYPE.CUSTOMER,
  };
  public show() {
    this.errors = {};
    this.isShow = true;
  }

  public async onSearch() {
    if (!this.search.email) {
      this.errors = { email: ["Please input"] };
      return;
    }
    this.noResult = false;
    this.customer = new User();
    const result = await userApi.index(this.search);

    if (result.length > 0) {
      this.customer = result[0];
      this.errors = {};
      this.noResult = false;
    } else {
      this.noResult = true;
    }
  }

  public usingCustomer() {
    this.$emit('selected', this.customer);
    this.isShow = false;
  }

  @Watch('isShow')
  public checkDisplayModal() {
    if (this.isShow) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }
}
